import React, { useEffect, useMemo, useState } from 'react';
import { Markdown as MD } from '@features/markdown/components/Markdown';
import Element from './Element';
import { zarazService } from '@/services';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '@settings';
import Anchor from '@components/tailwind/Anchor';
import classNames from 'classnames';

const Link = ({ attributes: { label, url, trackAs }, className = '' }) => {
  return (
    <div>
      <Anchor
        href={url}
        title={trackAs}
        className={classNames(
          'tw:block tw:w-full tw:font-body tw:text-sm tw:text-neutrals-graphite tw:hover:text-neutrals-graphite tw:hover:underline',
          className
        )}
        onClick={() => {
          zarazService.ecommerce.productClicked('main_nav', 'Main Nav', { name: trackAs || label });
        }}>
        {label}
      </Anchor>
    </div>
  );
};

export default Link;
